import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { usePatientByIdQuery } from "@/modules/patients/services/usePatientByIdQuery"

function usePatientSocialHistory(patientId: string, countryCode: Country) {
  // We are fetching from the store but we should pass Fragment top down and not rely on this
  // Currently we can't do this because of the drawer code architecture
  const appointmentId = useAppointmentParam()
  const [patientData] = usePatientByIdQuery(patientId, countryCode, appointmentId)
  return patientData.patientById!.socialHistory!
}

export { usePatientSocialHistory }
